import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import { pagesRoute, posRoutes, publicRoutes } from "./router.link";

import PosLayout from "./posLayout";
import AuthPages from "./authPages";
import HeaderLayouts from "./headerLayout";
import { configSiteTitle } from "../config/brandConfig";

const AllRoutes = () => {
	useEffect(() => {
		document.title = configSiteTitle; // Dynamically update the page title
	}, []);


	return (
		<div>
			<Routes>

				<Route element={<HeaderLayouts />}>
					{publicRoutes.map((route, id) => (
						<Route path={route.path} element={route.element} key={id} />
					))}
				</Route>
				<Route element={<PosLayout />}>
					{posRoutes.map((route, id) => (
						<Route path={route.path} element={route.element} key={id} />
					))}
				</Route>
				<Route element={<AuthPages />}>
					{pagesRoute.map((route, id) => (
						<Route path={route.path} element={route.element} key={id} />
					))}
				</Route>
			</Routes>
		</div>
	);
};
export default AllRoutes;
